import * as React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';

const item = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
};

function ProductValues() {
  return (
    <Box
      component="section"
      sx={{ display: 'flex', overflow: 'hidden', bgcolor: 'secondary.light' }}
    >
      <Container sx={{ mt: 6, mb: 6, display: 'flex', position: 'relative' }}>
        <Box
          component="img"
          src="/static/themes/onepirate/productCurvyLines.png"
          alt="curvy lines"
          sx={{ pointerEvents: 'none', position: 'absolute', top: -180 }}
        />
        <Grid container spacing={5}>
          <Grid item xs={12} md={6}>
            <Box sx={item}>
              <Box
                component="img"
                src="/static/themes/onepirate/productValues2.svg"
                alt="suitcase"
                sx={{ height: 55 }}
              />
              <Typography variant="h6" sx={{ my: 3 }}>
                고객센터
              </Typography>
              <Typography variant="h5">
                <a href="tel:02-535-0537" style={{ textDecoration: 'none', color: 'inherit' }}>
                02-535-0537
                </a>
              </Typography>
              <Typography variant="h5">
              <a href="tel:010-3201-0537" style={{ textDecoration: 'none', color: 'inherit' }}>
              010-3201-0537
                </a>
              </Typography>
              <Typography variant="h5">
                {
                  '(Fax)02-535-5672'
                }
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={item}>
              <Box
                component="img"
                src="/static/themes/onepirate/productValues3.svg"
                alt="graph"
                sx={{ height: 55 }}
              />
              <Typography variant="h6" sx={{ my: 3 }}>
                입금계좌 (예금주: 명성)
              </Typography>
              <Typography variant="h5">
                {
                  'KB 국민은행'
                }
              </Typography>
              <Typography variant="h5">
                {'498125-01-028955'}
              </Typography>
            </Box>
          </Grid>
          {/* <Grid item xs={12} md={4}>
            <Box sx={item}>
              <Box
                component="img"
                src="/static/themes/onepirate/productValues3.svg"
                alt="clock"
                sx={{ height: 55 }}
              />
              <Typography variant="h6" sx={{ my: 5 }}>
                Exclusive rates
              </Typography>
              <Typography variant="h5">
                {'By registering, you will access specially negotiated rates '}
                {'that you will not find anywhere else.'}
              </Typography>
            </Box>
          </Grid> */}
        </Grid>
      </Container>
    </Box>
  );
}

export default ProductValues;
